import { render, staticRenderFns } from "./LeoReList.vue?vue&type=template&id=0a985b50&scoped=true&"
import script from "./LeoReList.vue?vue&type=script&lang=js&"
export * from "./LeoReList.vue?vue&type=script&lang=js&"
import style0 from "./LeoReList.vue?vue&type=style&index=0&id=0a985b50&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a985b50",
  null
  
)

export default component.exports